export default __webpack_public_path__ + "static/media/iconicChair.0cdef783.png";